<div class="checkMarkIcon">
    <i class="fas fa-check-circle"></i>
</div>
<h2 class="checkMarkHeading">Submission complete</h2>

<p>
    Your report has been successfully submitted to the District of North Vancouver. Thank you for taking the time to
    notify us about this problem.
    <ng-container *ngIf="!!contactInfo.email">
        <br><br><span>A copy of your report, including your case number, has been sent to your email.</span>
        <br><br><span>If you want to provide any additional information, or follow up on the status of your report,
            please email <a href="mailto:inquiries@dnv.org?subject=Problem Submission Inquiry"
                class="lnk">inquiries@dnv.org</a> and include your case number in your email.</span>
    </ng-container>

    <ng-container *ngIf="!contactInfo.email">
        <br><br><span>If you want to provide any additional information, or follow up on the status of your report,
            please email <a href="mailto:inquiries@dnv.org?subject=Problem Submission Inquiry"
                class="lnk">inquiries@dnv.org</a>.</span>
    </ng-container>
</p>

<div class="nextSteps bigDisplayOnly">
    <h3 class="stepsTitle">What happens next?</h3>
    <div class="stepsContainer">
        <div class="step">
            <span class="circleIcon">1</span>
            <span class="stepText">
                Your report has been forwarded to the appropriate department within the District based on the
                information that you provided.
            </span>
        </div>
        <div class="step">
            <span class="circleIcon">2</span>
            <span class="stepText">
                Your report will be reviewed and investigated by a staff member as soon as possible.
            </span>
        </div>
        <div class="step">
            <span class="circleIcon">3</span>
            <span class="stepText">
                If you left your contact details, you'll be notified when the problem has been resolved.
            </span>
        </div>
    </div>
</div>

<div class="nextStepsMobile smallDisplayOnly">
    <h3 class="stepsTitle" [class.expandedListIcon]="shouldExpandDropdown" (click)="setExpandCollapseIcon()">
        What happens next?
        <span [innerHTML]="getExpandCollapseIcon()"></span>
    </h3>

    <div class="stepsContainer" *ngIf="shouldExpandDropdown">
        <div class="step">
            <span class="circleIcon">1</span>
            <span class="stepText">
                Your report has been forwarded to the appropriate department within the District based on the
                information that you provided.
            </span>
        </div>
        <div class="step">
            <span class="circleIcon">2</span>
            <span class="stepText">
                The report will be reviewed and investigated by a member of staff within two business days.
            </span>
        </div>
        <div class="step">
            <span class="circleIcon">3</span>
            <span class="stepText">
                If you left your contact details, you'll be notified when the problem has been resolved.
            </span>
        </div>
    </div>
</div>